const t = {
  name: "LetterT",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 2V8H6V4H9V20H7V22H17V20H15V4H18V8H20V2H4ZM13 4V20H11V4H13Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as LetterT
};
